export const timerCounter = 18 * 60 * 1000;
export const mouseEvent = 'mouseover';
export const touchEvent = 'touchstart';
